module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"insertMergeField":"Insert merge field","recipient":"Recipient\u0027s {field}","firstName":"first name","lastName":"last name"}}')
  delete Component.options._Ctor
}
